import {
  ApplicationEnvType,
  CountryType,
  RelatedProducts,
} from '@frodo/models/types';
import { PageType } from '@frodo/models/enums';

export const EMAIL_PATTERN: RegExp =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-ZäöüÄÖÜ0-9](?:[a-zA-ZäöüÄÖÜ0-9-]*[a-zA-ZäöüÄÖÜ0-9])?\.)+[a-zA-ZäöüÄÖÜ0-9](?:[a-zA-Z0-9-]*[a-zA-ZäöüÄÖÜ0-9])?$/;
export const PASSWORD_PATTERN: RegExp = /^.{8,128}$/;

export const CDN_ASSETS_BASE_URL = 'https://media.contorion.de/content/shop_front';

export const B2B = 'b2b';
export const B2C = 'b2c';
export const KEY_ENTER = 'Enter';
export const COOKIE_CUSTOMER_THEME_TYPE = 'customerThemeType';
export const COOKIE_USER_ID = 'userid';
export const COOKIE_SEARCH_HISTORY_KEY = 'search_history';
export const LOCAL_STORAGE_SETTINGS_KEY = 'settings';
export const LOCAL_STORAGE_PRODUCT_HISTORY_KEY = 'productHistories';
export const IS_FIRST_TIME_PDP_KEY = 'isFirstTimePDP';

export const EXPRESS_DELIVERY_BLOCK_NAME = 'express-delivery-modal-v2';

/********* search constants ********/
export const ACCESSORIES_RELATIONSHIP = 'zubehoer';

export const SEARCH_QUERY_KEYS = {
  searchTerm: 'q',
  categoryCode: 'c',
  pageNumber: 'p',
  pageSize: 'pageSize',
  sort: 'sort',
  sku: 'sku',
  relationship: 'relationship',
};

export const FACETS_PRIORITY: Record<string, number> = {
  manufacturer: 1,
  badge: 2,
  final_net_price: 3,
  final_gross_price: 3,
  delivery_option: 4,
};

export const SEARCH_DEFAULT_PAGE_SIZE = 40;
export const SEARCH_DEFAULT_SORT_ORDER = 'relevance';
export const FACETS_WITH_SEARCH: string[] = ['manufacturer'];
export const B2B_EXCLUDE: string[] = ['final_gross_price'];
export const B2C_EXCLUDE: string[] = ['final_net_price'];
export const TARGET_ELEMENT_ID = {
  sort: 'sort-filter',
  category: 'category-filter',
};
export const SEARCH_HISTORY_COOKIE_OPTIONS = {
  expiration: 7 * 24 * 60 * 60 * 1000, //keep it for 7 days
  path: '/',
};

export const MAX_SAVED_SEARCH_TERMS = 5;
export const MAX_LAST_SEEN_PRODUCTS_SEARCH_FLYOUT = 3;
export const MAX_MOST_SEARCHED_TERMS = 5;
export const MAX_KEYWORD_ITEMS_SEARCH_FLYOUT = 8;

// Keys that preserve the CRP product preview
export const PREVIEW_PRESERVE_KEYS: Record<string, string> = {
  sort: 'sort',
  pagination: 'pagination',
};

/*********************************/
export const COUNTRY_DE: CountryType = 'de';
export const COUNTRY_AT: CountryType = 'at';
export const COUNTRY_IT: CountryType = 'it';
export const COUNTRY_NL: CountryType = 'nl';
export const COUNTRY_FR: CountryType = 'fr';

export const DEVELOPMENT_ENV: ApplicationEnvType = 'development';
export const PRODUCTION_ENV: ApplicationEnvType = 'production';
export const QUALITY_ENV: ApplicationEnvType = 'quality';
export const STAGING_ENV: ApplicationEnvType = 'staging';

export const ROUTES: Partial<Record<PageType, string>> = {
  home: '/',
  cart: '/cart',
  search: '/search',
  category: '/c',
  productDetail: '/p',
};

export const CUSTOMER_ORDER_DETAILS_PATH = '/customer/order-details';
export const CUSTOMER_ORDER_DETAILS_ORDER_QUERY = 'order';

export function getCustomerOrderDetailsUrl(orderNumber: string): string {
  return `${CUSTOMER_ORDER_DETAILS_PATH}?${CUSTOMER_ORDER_DETAILS_ORDER_QUERY}=${orderNumber}`;
}

export const YVES_PAGE_TYPE_MAP: Partial<Record<PageType, string>> = {
  default: 'default',
  cart: 'cart',
  category: 'category',
  noResult: 'no search result page',
  productDetail: 'product detail',
  search: 'search result',
};

export const BOT_PATTERN =
  /Googlebot|Mediapartners-Google|AdsBot-Google|APIs-Google|FeedFetcher-Google|Google Favicon|bot|spider|crawl|scanner|slurp|python-requests|python-urllib|wget|scrapy|curl|Headless|Optimizer|HTTP-Monitor|SpeedCurve|Contorion|BingPreview|Google|Google-Ads|ruby|GoogleProber|GoogleAssociationService|GoogleOther|YOURLS|lua|Iframely|adbeat|omgili|Asana|Proxy|AHC|CFNetwork|Riddler|Test|Go-http-client|Prewave|facebookexternalhit|unfurlist|simple|Viber|Webex|Link|Postman|axios|ias|Expanse|Apache/i;

export const PAGE_TYPE_VCT_MAP: Partial<Record<PageType, string>> = {
  home: 'ho',
  cart: 'ca',
  category: 'cp',
  search: 'sp',
  productDetail: 'pd',
};

/**
 * SKU regex: optional (c|b) prefix, 4+ digits, optional quantity suffix (x\d+).
 * Matches e.g. 12345, c12345, b12345x2.
 */
export const SKU_PATTERN = '(?:c|b)?\\d{4,}(?:x\\d+)?';

/****Campaign constants****/
export const PDP_VOUCHER_CAMPAIGN = 'pdp-voucher';
export const PDP_TOP_BANNER_CAMPAIGN = 'pdp-top-banner';
export const PDP_SOCIAL_PROOF_CAMPAIGN = 'pdp-social-proof';

/****PDP reviews****/
export const PDP_REVIEWS_ANCHOR_ID = 'reviews';
export const INITIAL_VISIBLE_REVIEWS = 3;
export const REVIEWS_PAGE_SIZE = 10;
export const REVIEWS_SCROLL_OFFSET_PX = 50;

export const RELATED_PRODUCT_PRIORITY_KEYS = [
  'applicationExtensions',
  'consumables',
  'crossSellRecommendations',
  'generalAddOns',
] as const satisfies ReadonlyArray<keyof RelatedProducts>;

/****Error ****/
export const DEFAULT_ERROR_MESSAGE = 'An unexpected error occurred';
